import { connect } from 'react-redux';
import { fetchTrackingNote, editTrackingNote } from '../../actions/tracking_actions';
import TrackingNoteModal from '../../components/Purchase/trackingNoteModal';

const mapStateToProps = (state) => {
  return {
    notes: state.trackingNote.notes,
  };
};

const TrackingNoteModalContainer = connect(mapStateToProps, { fetchTrackingNote, editTrackingNote })(TrackingNoteModal);

export default TrackingNoteModalContainer;



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/trackingNoteModal.jsx